import getIn from 'transmute/getIn';
import { createSelector } from 'reselect';
import { getCurrentViewId } from '../../thread-list/selectors/getCurrentViewId';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
export const getSortOrderFromState = getIn(['sortOrder']);
export const getSortOrder = createSelector([getCurrentViewId, getCurrentInboxId, getSortOrderFromState], (viewId, inboxId, sortOrder) => {
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
  return getIn([`${inboxId}`, viewId], sortOrder) || 'DESC';
});